import styled from 'styled-components';

const SIDE_CELL_WIDTH = '7.1875rem';

export const Table = styled.div`
	display: flex;
	width: 100%;
	margin-top: 1.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
`;

export const Half = styled.div`
	flex: 1 1 0;
	min-width: 0;

	& + & {
		border-left: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	height: 3rem;
	padding: 1rem;
	border-bottom: 1px solid ${({ theme }) => theme.palette.secondary[150]};
`;

export const FactorRow = styled.div`
	display: flex;
	align-items: center;
	height: 2rem;
	padding: 0.5rem 1rem;

	& + & {
		border-top: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}
`;

export const Label = styled.span`
	flex: 1 1 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
`;

export const SideCell = styled.span`
	flex: 0 0 ${SIDE_CELL_WIDTH};
	width: ${SIDE_CELL_WIDTH};
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
	text-align: center;
`;

export const RiskBody = styled.div`
	display: flex;
	height: 10rem;
`;

export const RiskCell = styled.div`
	flex: 1 1 0;
	min-width: 0;
	padding: 1rem;

	& + & {
		border-left: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	}
`;

export const RiskSide = styled.span`
	display: block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
`;

export const RiskScore = styled.span`
	display: block;
	margin-top: 0.625rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5625rem;
	font-weight: 600;
	line-height: 2rem;
`;

export const RiskDescription = styled.span`
	display: block;
	margin-top: 0.625rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	line-height: 1.25rem;
`;
